import { ElMessage, ElMessageBox } from "element-plus";
import { useRouter } from "vue-router";
import { deployModel, deleteModel } from "@/api/model";
import { postDownload } from "@/utils";

export default function useModelAdjust(getList) {
  const router = useRouter();

  // 点击编辑
  const handleEdit = (row) => {
    router.push({ path: "/portal/framework/design", query: { id: row?.id || null } });
  };

  // 点击删除
  const handleDelete = (row) => {
    ElMessageBox.confirm("确定删除此流程模型吗?", "警告", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        deleteModel(row.id).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("删除成功");
            getList();
          }
        });
      })
      .catch(() => { });
  };

  // 点击部署
  const handleDeploy = (row) => {
    deployModel(row.id).then((res) => {
      if (res.code == "2000") {
        ElMessage.success("部署成功");
        getList();
      }
    });
  };

  // 点击导出
  const handleExport = (row) => {
    ElMessageBox.confirm("确定导出此流程模型文件吗?", "导出", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "success",
    })
      .then(() => {
        postDownload(
          "/process/exportSinge?id=" + row.id,
          {},
          row.processName + ".bpmn"
        );
      })
      .catch(() => { });
  };
  return {
    handleEdit,
    handleDelete,
    handleDeploy,
    handleExport,
  };
}
